<template>
  <!-- 对话框 -->
  <el-dialog
    :title="title"
    :visible.sync="show"
    :before-close="closeDialog"
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
    style="width: 100%; margin: 0 auto"

  >
    <!-- 基本信息表单 -->
    <div class="form-box" style="max-height: 70vh; overflow-y: auto" v-loading="loading">
      <el-form label-width="80px">
        <!-- 推广中存在照片 -->
        <div
          style="width:90%;height:auto"
          v-if="title == '推广审核'"
        >
          <el-image
            :preview-src-list="srcList"
            v-for="(item, index) in img_arr"
            :key="index + '2'"
            :label="item"
            :value="item"
            style="width: 100px; height: 100px;margin-right:5px"
            :src="item"
          ></el-image>
        </div>
        <div v-if="title == '推广审核'">
          <!-- 推广审核 -->
          <el-form-item label="审核判定:" label-width="120px">
            <el-radio-group v-model="submit_data_t.status">
              <el-radio-button label="1">通过</el-radio-button>
              <el-radio-button label="2">拒绝</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="系统备注:" label-width="120px">
            <el-input
              type="textarea"
              autosize
              v-model="submit_data_t.remarks"
              :placeholder="submit_rules_t.remarks.placeholder"
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <!-- 报名审核 默认为同意，不可重复审核为同意，所以把同意禁用了-->
          <el-form-item label="审核判定:" label-width="120px">
            <el-radio-group v-model="submit_data_b.join_status">
              <el-radio-button disabled label="1">通过</el-radio-button>
              <el-radio-button label="2">拒绝</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="系统备注:" label-width="120px">
            <el-input
              type="textarea"
              autosize
              v-model="submit_data_b.remarks"
              :placeholder="submit_rules_b.remarks.placeholder"
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>

      <div style="display: flex; justify-content: center">
        <el-button type="primary" @click="determineonSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
var _this;
export default {
  props: {
    isShow: Boolean,
    data: "",
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;
      _this.submit_data_b.driver_code = _this.data.driver_code;
      _this.submit_data_b.task_code = _this.data.task_code;

      _this.submit_data_t.driver_code = _this.data.driver_code;
      _this.submit_data_t.task_code = _this.data.task_code;

      if(_this.data.status_des == "推广中" || _this.data.status_des == "已结束") {
        _this.title = '推广审核'
        _this.getPromotionSignRecord();

      }else{

        _this.title = '报名审核'
        _this.loading = false;
      }

    },
  },
  data() {
    return {
      show: false,
      loading:true,
      submit_url: "",
      title: "报名审核",
      img_arr: [],

      srcList: [],

      // 报名审核表单数据
      submit_data_b: {
        driver_code: "",


        task_code: "",
        join_status: "1",

        remarks: "",
      },
      // 推广审核表单数据
      submit_data_t: {
        driver_code: "",
        city_code: "",

        task_code: "",

        status: "",
        remarks: "",
      },

      submit_rules_b: {
        join_status: {
          placeholder: "审核判定",
          rules: {
            required: true,
            message: "未选择审核判定状态",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        remarks: {
          placeholder: "审核原因",
          rules: {
            required: true,
            message: "审核原因200个汉字以下",
            regulation: "elt_str",
            rulesData: 200,
          },
        },
      },
      submit_rules_t: {
        status: {
          placeholder: "审核判定",
          rules: {
            required: true,
            message: "未选择审核判定状态",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        remarks: {
          placeholder: "审核原因",
          rules: {
            required: true,
            message: "审核原因200个汉字以下",
            regulation: "elt_str",
            rulesData: 200,
          },
        },
      },
    };
  },
  created() {
    _this = this;
  },
  methods: {
    getPromotionSignRecord() {
      _this
        .$post("Offlinepromotion/getPromotionSignRecord", {

          task_code: _this.submit_data_t.task_code,
          driver_code: _this.submit_data_t.driver_code,
        })
        .then((res) => {
          _this.submit_data_t.status = res.data.status;
          _this.submit_data_t.remarks = res.data.remarks;

          for (let i = 0; i < res.data.img_list.length; i++) {
            _this.img_arr.push(res.data.img_list[i].img_hash);
            _this.srcList.push(res.data.img_list[i].img_hash);
          }

          _this.loading = false;


        })
        .catch((err) => {});
    },
    // 关闭方法
    closeDialog() {
      _this.show = false;

      _this.loading = true;

      _this.submit_url = "";
      _this.title = "";

      _this.img_arr = [];
      _this.srcList = [];
      _this.submit_data_b = {
        driver_code: "",


        task_code: "",
        join_status: "1",

        remarks: "",
      };
      _this.submit_data_t = {
        driver_code: "",


        task_code: "",
        status: "",

        remarks: "",
      };
    },

    // 提交按钮
    determineonSubmit() {
      let submit_data;
      let submit_rules;
      if (_this.title == "推广审核") {
        _this.submit_url = "/Offlinepromotion/auditPromotionDriver";
        submit_data = _this.submit_data_t;
        submit_rules = _this.submit_rules_t;
      } else {
        _this.submit_url = "/Offlinepromotion/auditJoinDriver";
        submit_data = _this.submit_data_b;
        submit_rules = _this.submit_rules_b;
      }


      _this
        .$post(_this.submit_url, submit_data, submit_rules)
        .then((res) => {
          _this.$message.success(res.msg);
          // 向父组件通讯刷新表格内容
          _this.$emit("onSubmit");
          // 关闭对话框
          _this.closeDialog();
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.avatar-uploader img {
  display: block;
  width: 100%;
  height: 100%;
}

.el-form-item__content {
  position: relative;
}
</style>
